export default __webpack_public_path__ + "static/media/10-gm-unachieved_old.a39b6710.svg";